(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-mini.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-mini.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const getMiniMapHandler = svs.lyckoplatsen.components.shared_map.getMiniMapHandler;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const wagersAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.wagersAtom;
const MapMini = () => {
  const mapHandlerMini = useMemo(getMiniMapHandler, []);
  const mapId = 'map-mini';
  const wagers = useAtomValue(wagersAtom);
  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      dragging: false,
      zoomSnap: 0.1,
      minZoom: 1,
      zoomControl: false,
      scrollWheelZoom: false,
      geoJsonInv: false
    };
    mapHandlerMini.createMap(mapOptions, wagers);
    return () => {
      mapHandlerMini.removeMap();
    };
  }, [mapHandlerMini, wagers]);
  return React.createElement("div", {
    id: mapId,
    className: "lp-map-mini",
    style: {
      height: '100%',
      width: '100%',
      zIndex: 0
    }
  });
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapMini
});

 })(window);